export default __webpack_public_path__ + "static/media/services_enviro_0.1c9022ee.jpg";